import React from "react";
import styles from "./Desc.module.scss";

function Desc({ value }) {
  return <div className={styles.desc}>{value}</div>;
}

export default Desc;
